import { memo, useMemo } from 'react';
import CosmosPlayer from 'components/CosmosPlayer/CosmosPlayer';
import { PlayerMetaType } from 'components/CosmosPlayer/types';

const InlineAudioDisplay = memo((asset: any) => {
  const { files, title } = asset;

  // Memoize video metadata based on asset data
  const audioMeta: PlayerMetaType = useMemo(() => {
    const source = files?.audio?.url || '';
    return {
      uniqueId: asset?.uuid || asset?.id,
      source: source,
      title: title || 'Audio File',
      alt: title || 'Audio File',
      type: 'audio',
    };
  }, [asset?.id, asset?.uuid, files?.audio?.url, title]);

  return (
    <CosmosPlayer
      playerMeta={audioMeta}
      width="100%"
      height="3rem"
    />
  );
});
InlineAudioDisplay.displayName = 'InlineAudioDisplay';

export default InlineAudioDisplay;
